import { render, staticRenderFns } from "./BoxScore.vue?vue&type=template&id=96b40758"
import script from "./BoxScore.js?vue&type=script&lang=js&external"
export * from "./BoxScore.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports